
class ApiError extends Error {
  constructor (originalError, message = null) {
    super(message || originalError.message);
    this.name = 'ApiError';
    this.originalError = originalError;
  }
}

export default ApiError;
